import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-comments',
  imports: [],
  templateUrl: './icon-comments.component.html',
  styleUrl: './icon-comments.component.scss'
})
export class IconCommentsComponent {

}
